export const roles =[
  { name: 'Cloud Admin', value: 'CloudAdmin', isAdmin: true},
  { name: 'Company Admin', value: 'CompanyAdmin', isAdmin: true},
  { name: 'User', value: 'User', isAdmin: false},
  { name: 'Power User', value: 'PowerUser', isAdmin: false}
];
